import { render } from "./LinkedBuild.vue?vue&type=template&id=5b98a7dc&scoped=true&ts=true"
import script from "./LinkedBuild.vue?vue&type=script&lang=ts"
export * from "./LinkedBuild.vue?vue&type=script&lang=ts"

import "./LinkedBuild.vue?vue&type=style&index=0&id=5b98a7dc&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b98a7dc"]])

export default __exports__